import { render, staticRenderFns } from "./PageProfileView.vue?vue&type=template&id=02b08c23&scoped=true&"
import script from "./PageProfileView.vue?vue&type=script&lang=ts&"
export * from "./PageProfileView.vue?vue&type=script&lang=ts&"
import style0 from "./PageProfileView.vue?vue&type=style&index=0&id=02b08c23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b08c23",
  null
  
)

export default component.exports